import { useEffect, useState } from "react";
import { getQrCode } from "../../services/branch";

export const isQrImage = (value) => value instanceof Blob && value.size > 0 && value.type.startsWith("image/");
export const downloadQrImage = (blob) => {
  if (!isQrImage(blob)) return false;
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "QR_Pay.png";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
  return true;
};

export default function useBookingQr(bookingId) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ imageUrl: "", blob: null, loading: false, error: "" });
  useEffect(() => {
    let active = true;
    let imageUrl = "";
    const controller = new AbortController();
    setState({ imageUrl: "", blob: null, loading: true, error: "" });
    (async () => {
      try {
        if (!bookingId) throw new Error("Missing booking ID");
        const blob = await getQrCode(bookingId, controller.signal);
        if (!active) return;
        if (!isQrImage(blob)) throw new Error("Invalid QR image");
        imageUrl = URL.createObjectURL(blob);
        setState({ imageUrl, blob, loading: false, error: "" });
      } catch {
        if (active) setState({ imageUrl: "", blob: null, loading: false, error: "Chưa tải được QR nhận phòng. Vui lòng thử lại." });
      }
    })();
    return () => { active = false; controller.abort(); if (imageUrl) URL.revokeObjectURL(imageUrl); };
  }, [bookingId, attempt]);
  return { ...state, retry: () => setAttempt((value) => value + 1), download: () => downloadQrImage(state.blob) };
}
